/** PROBATION-REVIEW-001 P3 — shared constants/helpers for probation UI. */
export const API = process.env.REACT_APP_BACKEND_URL || '';
export const h = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
export const err = (e) => e?.response?.data?.detail?.message || (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : null) || e?.message || 'Request failed';
export const MIN_TEXT = 20;
export const MIN_REASON = 10;
export const RATINGS = [
  { key: 'quality', label: 'Quality' }, { key: 'productivity', label: 'Productivity' },
  { key: 'attendance', label: 'Attendance' }, { key: 'conduct', label: 'Conduct' },
];
export const addMonths = (iso, m) => {
  if (!iso) return null;
  const d = new Date(`${iso}T00:00:00`); const day = d.getDate();
  d.setDate(1); d.setMonth(d.getMonth() + m);
  d.setDate(Math.min(day, new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()));
  return d.toISOString().slice(0, 10);
};
